import * as constants from "../../constants";
import { IAuthAction, ILoginSuccessAction, IStore } from "../../types";
import { Map } from "immutable";
import { mutateState } from "../../helpers/mutate-state";

const TOKEN = "token";
const IS_LOGGED_IN = "isLoggedIn";
const STORE_DATA = "storeData";

export interface IAuthReducerState {
  [TOKEN]: string;
  [IS_LOGGED_IN]: boolean;
  [STORE_DATA]: IStore;
}

const initialState: IAuthReducerState = Map({
  [TOKEN]: "",
  [IS_LOGGED_IN]: false,
  [STORE_DATA]: {},
}).toJS();

const authReducer = (
  state: IAuthReducerState = initialState,
  action: IAuthAction
): IAuthReducerState => {
  switch (action.type) {
    case constants.loginAction.fulfilled: {
      return mutateState(state, (map) => {
        map.set(TOKEN, (action as ILoginSuccessAction).payload.token);
        map.set(IS_LOGGED_IN, true);
        map.set(STORE_DATA, {
          ...(action as ILoginSuccessAction).payload,
        });
      });
    }
    default:
      return state;
  }
};

export default authReducer;
